// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DetailPay */
.DetailPay {
  display: flex;
  flex-direction: column;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/screens/salary_specification/detail/DetailPay.scss"],"names":[],"mappings":"AAAA,cAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;AACJ","sourcesContent":["/* DetailPay */\n.DetailPay {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
